<template>
    <div>
        <el-menu @select="handleSelect" class="sidebar" :default-active="activeItem" :collapse="isCollapsed">
            <el-menu-item v-for="elem in components" v-bind:key="elem.name" :index="elem.name">
                <font-awesome-icon :icon="elem.icon"/>
                <span slot="title">{{ $t(elem.label ) }}</span>
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
    import model from '@/model/index'

    export default {
        name: 'sidebar',
        watch: {
            width() {
                this.isCollapsed = (this.width < 1000)
            }
        },
        computed: {
            position () {
                let style = '';
                if (this.scrollY < 70) {
                    style = `top: 0px; position: absolute;`
                } else {
                    style = `top: 0px; position: fixed; margin-top: 0px`
                }
                return style
            },
            activeItem() {
                if (this.$route.name === 'MenuItems') {
                    return 'menu_items'
                }
                
                return this.$route.name.toLowerCase()
            }
        },
        data() {
            return {
                components: model.getSidebarComponents(),
                width: 1000,
                scrollY: 0,
                height: 0,
                isCollapsed: false,
                active: ''
            }
        },
        created() {
            let self = this
            self.width = window.innerWidth
            this.$nextTick(function () {
                window.addEventListener('resize', function (event) {
                    self.width = window.innerWidth
                })
                window.addEventListener('scroll', function (event) {
                    self.scrollY = window.scrollY
                    self.height = window.innerHeight
                })
            })
        },
        methods: {
            handleSelect (param) {
                this.$router.push(`/dashboard/${param}`)
            },
            
        }
    }
</script>

<style scoped>
    svg:not(:root).svg-inline--fa {
        font-size: 20px;
        margin-right: 10px;
    }
    ::-webkit-scrollbar {
	width: 5px;
	}

	::-webkit-scrollbar-track {
	background-image: linear-gradient(0deg,#7e8ea1,#3c4655); 
	}

	::-webkit-scrollbar-thumb {
	background: #39404a; 
	}

	::-webkit-scrollbar-thumb:hover {
	background: #2d3136; 
    }

    .sidebar {
        position: fixed;
        z-index: 5;
        height: 100%;
        width: 200px;
        background-image: linear-gradient(0deg,#7e8ea1,#3c4655);
        margin: 0;
        padding-top: 70px;
        border: none;
        overflow-y: scroll;

        box-shadow: 1px 1px 5px -2px #888;
        -webkit-box-shadow: 1px 1px 5px -2px #888;
    }

    
    .el-menu-item i, .el-menu-item {
        margin-right: 18px;
        color: white !important;
    }
    
    li.el-menu-item.is-active {
        background: transparent;
        color: white !important;
        font-weight: 800 !important;
    }

     li.el-menu-item:hover {
         background: transparent;
         color: #9098a3 !important;
     }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue